// @flow

export { DisplayOpayBrand } from './display-opay-brand';
